import React, {FC, useEffect, useMemo} from 'react';
import {deliveryOptionsInterface, DeliveryType, gunOptionsInterface, StepProps} from "../types/types";
import DPDPointPickupReturn from "./substeps/DPDPointPickupReturn";
import DeliveryHomeReturnAtDPD from "./substeps/DeliveryHomeReturnAtDPD";
import RentalPointDatesSelector from "./substeps/RentalPointDatesSelector";
import DeliveryAtHomeReturnTransforce from "./substeps/DeliveryAtHomeReturnTransforce";
import { DeliveryManager } from "../data/DeliveryManager";
import { getBookingConfig } from "../data/price";
import { useAppDispatch, useAppSelector } from '../hooks';

const Step3: FC<StepProps> = ({setStepValidity}) => {
    const d = useAppDispatch;
    const deliveryOptions = useAppSelector((state) => {
        return state.delivery;
    });

    const bookingConfig = getBookingConfig();
    const manager = new DeliveryManager(bookingConfig);
    const layout = useMemo(() => {
        //@TODO move logic to separate class with readable method names
        if (manager.isDPDPointDelivery(deliveryOptions.deliveryType ?? '')) {
            return 'DPDPoint';
        } else if (deliveryOptions.deliveryType === DeliveryType.DPD || deliveryOptions.deliveryType === DeliveryType.DPDFree || deliveryOptions.deliveryType === DeliveryType.DPD50Discount) {
            return 'DPDHome';
        } else if (deliveryOptions.deliveryType === DeliveryType.Transforce || deliveryOptions.deliveryType === DeliveryType.TransforceBow || deliveryOptions.deliveryType === DeliveryType.TransforceFree || deliveryOptions.deliveryType === DeliveryType.Transforce50Discount) {
            return 'TransforceHome';
        } else {
            return 'RentalPoint';
        }
    }, [deliveryOptions]);
    return (
        <div>
            {layout === 'DPDPoint' && <DPDPointPickupReturn setStepValidity={setStepValidity} />}
            {layout === 'DPDHome' && <DeliveryHomeReturnAtDPD setStepValidity={setStepValidity} />}
            {layout === 'TransforceHome' && <DeliveryAtHomeReturnTransforce setStepValidity={setStepValidity} />}
            {layout === 'RentalPoint' && <RentalPointDatesSelector setStepValidity={setStepValidity} />}
        </div>
    );
};

export default Step3
;
